import React from 'react'
import { Theme } from '@pga/pga-component-library'
import { InfoIcon } from '../../Icons'
import { AlertBoxWrapper, AlertIconWrapper, AlertMessage } from './Styles/Shared.styles'

export default ({ children }) => {
  if (!children) return null
  return (
    <AlertBoxWrapper>
      <AlertIconWrapper>
        <InfoIcon color={Theme.colors.danger} size={24} style={{ padding: '0' }} />
      </AlertIconWrapper>
      <AlertMessage>
        {children}
      </AlertMessage>
    </AlertBoxWrapper>
  )
}
